








































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetUserInfo } from "@/request/yonghuquanxian";
@Component({})
export default class SjzxNavLeft extends Vue {
  @Prop()
  private cState;
  private user: any = { role: {} };
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 获取当前用户信息
   */
  private getCurrentUserInfo() {
    if (!this.center.project_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    GetUserInfo(this, params).then((data: any) => {
      this.$set(this, "user", data);
    });
  }
  /**
   * @description 判断当前用户在当前机构下能否显示某个功能
   */
  private canThisRoleUse(tool) {
    let canUse = false;
    try {
      switch (tool) {
        case "数据采集":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "监查痕迹":
          if (
            this.$store.state.roleControl["监查痕迹"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
      }
    } catch (e) {
      console.log(e);
    }
    return canUse;
  }
  /**
   * @description 跳转质量控制
   */
  private jumpZlkz() {
    localStorage.setItem(
      "zlkzFilters",
      JSON.stringify({
        institution_id: "",
        范围: [],
        user_ids: [],
        status: "",
        search: "",
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "更新时间",
        cSortValue: "0",
      })
    );
    this.$router.push("/main/sjzx/zlkz");
  }
  /**
   * @description 跳转监查痕迹
   */
  private jumpJchj() {
    localStorage.setItem(
      "jchjFilters",
      JSON.stringify({
        institution_id: "",
        zhenci: "",
        search: "",
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "创建时间",
        cSortValue: "0",
      })
    );
    this.$router.push("/main/sjzx/jchj");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getCurrentUserInfo();
  }
}
